// External libraries
import type { EasyPeasyConfig, Store } from 'easy-peasy';
import { createStore } from 'easy-peasy';

// Internal modules
import type { StoreModelType } from './models';
import { storeModel } from './models';
import { logger } from '../lib/logger';

export type TWeasleyStore = Store<StoreModelType>;

export const appStore: TWeasleyStore = createStore(storeModel);
logger.info('app_store_created');

// For testing purposes
export const createAppStore = (options?: EasyPeasyConfig): TWeasleyStore =>
  createStore(storeModel, options);
